import request, { get, post } from '@tools/request';

export const getSupportPayTypes = (params) => {
  return get('/otc/dictionary/getData', params);
};

// 查询用户信息
export const getUserInfo = () => get('/ucenter/user-info');

// 退出登录
export const logout = () => {
  return post('/logout');
};

/**
 * 获取用户VIP等级
 */
export const getUserVipInfo = () => {
  return get('/kucoin-web-front/fee/getExchangeLevelAndFee');
};

/**
 * 获取kyc状态
 */
export const getKysStatus = () => {
  return get('/kyc/kyc/status');
};

// 获取资金概览数据
export const getAssetDetail = (query) => {
  return get('/kucoin-web-front/asset/overview', query);
};
// 获取资金概览数据
export const getAssetDetail2 = (query) => {
  return get('/kucoin-web-front/v2/asset/overview', query);
};

/**
 * 获取法币汇率
 *
 * @param base    string 法币币种 如：USD
 * @param targets string
 */
export function getRates(base = 'USD', targets = '') {
  return get('/currency/rates', { base, targets });
}

/**
 * 获取交易所实时的币种对法币的价格
 *
 * @param base    string 法币币种 如：USD
 * @param targets string 数字货币币种，用于过滤数据， 如：BTC,KCS,ETH，参数只返回这三项的数据
 */
export function getPrices(base = 'USD', targets = '') {
  return get('/currency/prices', { base, targets });
}

// 获取系统可用语言列表
export function getLangList() {
  return get('/ucenter/languages');
}

// 获取主站域名列表
export function getManifestSiteList(baseURL) {
  if (baseURL) {
    return request('get', { url: '/sites', baseURL });
  }
  return request('get', { url: '/sites' });
}
export function getFeeDeductionConfig() {
  return get('/trade-marketing/config/getFeeDeductionConfig');
}

/**
 * 获取用户是否开启了KCS 抵扣手续费
 *
 * @return  {[type]}  [return description]
 */
export function checkIsKcsDiscountOn() {
  return get('/ucenter/is-kcs-deduction-open');
}

// 获取导航
export function getNavigation(payload) {
  return get('/kucoin-config/navigation/pc/enabled/navigationInfo', payload);
}

/**
 * 获取是否展示【新人专区】入口
 *
 */
const prefix = '/novice-zone';
export function getNewbieEntry(payload) {
  return request({
    method: 'get',
    url: `${prefix}/v2/web/novice/summary`,
    headers: payload || {},
  });
}
